module.exports = __webpack_public_path__ + "img/M@2x.17f5d3e0.jpg";